<template>
    <div id="app" class="hyphens-auto">
        <router-view></router-view>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import ApiService from "@/services/api.service";

    export default {
        name: 'App',
        components: {},
        computed: {
            ...mapGetters('auth', {
                'loggedIn': 'loggedIn',
                user: 'user'
            }),
            ...mapGetters('app', {
                GET_INVITATION: 'GET_INVITATION'
            }),
            ...mapGetters('dlGroupConfig', {
                getDlGroupName: 'getDlGroupName'
            })
        },
        created: function () {
            ApiService.mount401Interceptor();
            this.$store.dispatch('dlGroupConfig/getConfig').then(() => {
                document.documentElement.title = this.getDlGroupName;
                document.title = this.getDlGroupName;
            });

            if (this.loggedIn) {
                this.$store.dispatch('auth/getAcceptedApplications');
                this.$store.dispatch('auth/user').then(() => {
                    if (this.user) {
                        if (this.user.language !== '') {
                            this.$i18n.locale = this.user.language;
                        }
                    }
                });
                this.$store.dispatch('auth/filter');
            } else {
                let currentBrowserLocale = navigator.language;
                if (currentBrowserLocale.length > 1) {
                    let simpleBrowserLocale = currentBrowserLocale.substr(0, 2);
                    this.$i18n.locale = simpleBrowserLocale;
                }

                if (this.GET_INVITATION !== null) {
                    this.$store.dispatch('app/checkUpdateAvailabilityNeed').then((lang) => {
                        if (lang != '') {
                            this.$i18n.locale = lang;
                        }
                    });
                }
            }
            const html = document.documentElement; // returns the html tag
            html.setAttribute('lang', this.$i18n.locale);
        },
        destroyed() {
            ApiService.unmount401Interceptor();
        }
    }
</script>

<style>
    #app {
        font-family: Avenir, Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        -moz-hyphens: auto;
        -webkit-hyphens: auto;
        -ms-hyphens: auto;
        hyphens: auto;
        word-wrap: break-word;
        overflow-wrap: break-word;
    }
</style>